import React, {useState, ChangeEvent} from 'react';
import { SketchPicker, ColorResult } from 'react-color';
import './App.css';
import logo192 from './logo192.png'


function App() {

  const[disabled, setDisabled] = useState(true);
  const[color, setColor] = useState<string>("#ffffff");
  const[red, setRed] = useState<number>(255);
  const[green, setGreen] = useState<number>(255);
  const[blue, setBlue] = useState<number>(255);
  const[alfa, setAlfa] = useState<number>(1);
  const[H, setH] = useState<string>("0");
  const[S, setS] = useState<string>("0 %");
  const[L, setL] = useState<string>("100 %");



  // handleChange pro ruční zadání hodnot
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    
    const value = event.target.value;

		switch (event.target.name) {
		  case 'hex':
        setColor(`#${value}`);
        setRed(parseInt(value.slice(0, 2), 16));
        setGreen(parseInt(value.slice(2, 4), 16));
        setBlue(parseInt(value.slice(4, 6), 16));
        setAlfa(1);
			break;
		  case 'r':
        setRed(Number(value));
        toHex(Number(value), green, blue, alfa);
			break;
		  case 'g':
        setGreen(Number(value));
        toHex(red, Number(value), blue, alfa);
			break; 
		  case 'b':
        setBlue(Number(value));
        toHex(red, green, Number(value), alfa);
			break;
      case 'a':
        setAlfa(Number(value));
        toHex(red, green, blue, Number(value));
      break;
		default:
			break;
		};

	};



  // Výběr barvy přes picker a převod do RGB
  const handleChangePicker = (color: ColorResult) => {
    const valueColor = color.hex;
    setColor(valueColor);
    setRed(parseInt(valueColor.slice(1, 3), 16));
    setGreen(parseInt(valueColor.slice(3, 5), 16));
    setBlue(parseInt(valueColor.slice(5, 7), 16));
    setAlfa(1);
  };



  const toHex = (red:number, green:number, blue:number, alfa:number) => {

    console.log(`rgb(${red}, ${green}, ${blue}, ${alfa})`);

    if (alfa<1) {
      setColor(`#${componentToHex(red)}${componentToHex(green)}${componentToHex(blue)}${componentToHex(Math.round(alfa * 255))}`);
    } else {
      setColor(`#${componentToHex(red)}${componentToHex(green)}${componentToHex(blue)}`);
    }

    // převedení rgb na hodnoty 0-1 a deklarace proměnných
    const r = red/255;
    const g = green/255;
    const b = blue/255;
    var h = 0;
    var s = 0;
    var l = 0;
    var min = 0;
    var max = 0;

    // určení minimální a maximální hodnoty pro výpočet l
    if (r===g && r===b) { // všechny RGB hodnoty jsou stejné (nulová saturace - odstín šedé)
      min = r
      max = r
    } else {
      min = Math.min(r, g, b);
      max = Math.max(r, g, b);
    }

    // výpočet l
    console.log('l-pred:' +(min + max)/2)
    l = (min + max)/2
    console.log('l-po:' +l)

    // výpočet s
    if (min===max) {
      s = 0
    } else if (l>0.5){
      s = (max-min)/(2-max-min)
    } else {
      s = (max-min)/(max+min)
    }

    // výpočet h
    if (min===max) {
      h = 0
    } else if (max===r) {
      h = ((g-b)/(max-min))*60
    } else if (max===g) {
      h = (2+((b-r)/(max-min)))*60
    } else {
      h = (4+((r-g)/(max-min)))*60
    }

    // přepočet v přápadě negativní hodnoty h
    if (h<0) {
      h += 360
    }

    // nastavení hodnot HSL
    setH(`${Math.round(h)}`);
    setS(`${Math.round(s*100)} %`);
    setL(`${Math.round(l*100)} %`);

  }



  const componentToHex = (component:number) => {
    if (disabled===false) {
      var hex = component.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    }
  }



  const handleDisable = () => {
    setDisabled(!disabled);
    setColor('#ffffff');
    setRed(255);
    setGreen(255);
    setBlue(255);
    setAlfa(1);
    setH("0");
    setS("0 %");
    setL("100 %");
  }



  // CSS
  const left = {
    backgroundColor: color,
    height: '284.6px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    left: '0%',
    width: '50%',
    position: 'absolute' as 'absolute',
  }

  const blank = {}

  const vanish = {
    display: 'none'
  }

  const behind = {
    top: "50%",
    left: "25%",
    position: "absolute" as "absolute",
    zIndex: "-1",
    width: "200px",
    height: "200px",
    transform: "translate(-50%, -50%)",
  }

  const center = {
    backgroundColor: color,
    height: '284.6px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row' as 'row',
    alignItems: 'center',
    width: '100%',
    position: 'absolute' as 'absolute',
  }

  const right = {
    backgroundColor: color,
    height: '284.6px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    left: '50%',
    width: '50%',
    position: 'absolute' as 'absolute',
  }

  const white = {
    color: 'white'
  }

  const black = {
    color: 'black'
  }

  const ovladani = {
    backgroundColor: 'white',
    minHeight: '20%',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row' as 'row',
    alignItems: 'center',
    top: '60%',
    width: '100%',
    position: 'absolute' as 'absolute',
  }
  // CSS
  


  return (
    <div className="App">
      <h1>Převodník barev</h1>
      <div className="nahled" style={disabled ? blank : center}>
        <div className="levy-nahled" style={disabled ? left : vanish}>
          <SketchPicker color={ color } disableAlpha={true} onChange={handleChangePicker} />
        </div>
        <div className="pravy-nahled" style={disabled ? right : blank}>
          <img style={disabled ? vanish : behind} src={logo192} alt={"React Logo"} /> 
          <table>
            <tr>
              <th style={white}>{`Vzorový text: ${color.toUpperCase()}`}</th>
            </tr>
            <tr>
              <th style={black}>{`Vzorový text: ${color.toUpperCase()}`}</th>
            </tr>
          </table>
        </div>
      </div>
      <br /><br />
      <div className="ovladani" style={ovladani}>
        <table>
          <tr>
            <th>Hex</th>
            <th>Red</th>
            <th>Green</th>
            <th>Blue</th>
            <th style={disabled ? vanish : blank}>Alfa</th>
            <th style={disabled ? vanish : blank}>Hue</th>
            <th style={disabled ? vanish : blank}>Saturation</th>
            <th style={disabled ? vanish : blank}>Light</th>
          </tr>
          <tr style={disabled ? blank : vanish}>
            <td><input name="hex" maxLength={6} value={(color.substring(1, 7)).toUpperCase()} onChange={handleChange}></input></td>
            <td><input name="r" type="text" disabled={true} value={red}></input></td>
            <td><input name="g" type="text" disabled={true} value={green}></input></td>
            <td><input name="b" type="text" disabled={true} value={blue}></input></td>
          </tr>
          <tr style={disabled ? vanish : blank}>
            <td><input name="hex" disabled={true} value={color.toUpperCase()}></input></td>
            <td><input name="r" type="number" min="0" max="255" step="1" value={red} onChange={handleChange}></input></td>
            <td><input name="g" type="number" min="0" max="255" step="1" value={green} onChange={handleChange}></input></td>
            <td><input name="b" type="number" min="0" max="255" step="1" value={blue} onChange={handleChange}></input></td>
            <td><input name="a" type="number" min="0" max="1" step="0.01" value={alfa} onChange={handleChange}></input></td>
            <td><input name="h" type="text" disabled={true} value={H}></input></td>
            <td><input name="s" type="text" disabled={true} value={S}></input></td>
            <td><input name="l" type="text" disabled={true} value={L}></input></td>
          </tr>
          <tr style={disabled ? blank : vanish}>
            <td colSpan={4}><button onClick={handleDisable}>{"Hex ➔ RGB"}</button></td>
          </tr>
          <tr style={disabled ? vanish : blank}>
            <td colSpan={8}><button onClick={handleDisable}>{"RGB ➔ Hex"}</button></td>
          </tr>
        </table>
      </div>
    </div>

  );
}

export default App;
